import { html } from 'lit';

export const helpIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 17h-2v-2h2v2Zm2.07-7.75-.9.92A3.4 3.4 0 0 0 13 15h-2v-.5a4.025 4.025 0 0 1 1.17-2.83l1.24-1.26A1.956 1.956 0 0 0 14 9a2 2 0 1 0-4 0H8a4 4 0 0 1 8 0c0 .844-.334 1.653-.93 2.25Z"
    />
  </svg>
`;
